import { Component, OnInit } from '@angular/core';
import { HelperService } from '../helper.service';
import { UserService } from '../user.service';
import {Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";  

import { HttpClient,HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-product-payment',
  templateUrl: './product-payment.component.html',
  styleUrls: ['./product-payment.component.css']
})
export class ProductPaymentComponent implements OnInit {

  
  constructor(private helper:HelperService, private router:Router, private user:UserService, private SpinnerService: NgxSpinnerService,private httpClient: HttpClient) {
    this.divReady = false;
    //this.helper.loginRedirect();
    this.user.getUnAllottedLicensesList().subscribe((res)=>{
        console.log(res);
        if(res.status == 1){
          const unllotedLinces = 'yes';
          localStorage.setItem('unllotesLinces',unllotedLinces); 
          //this.router.navigate(['/allot-license'])
          this.unAllotedLicense = res.data.length;
        }  
    })
   }

    unAllotedLicense = '';
    divReady = false;
    loggedInUserName: string = 'User';
    loggedInUserFirstName: string = 'User';
    loggedInUserEmail: string = '';
    productData = [];
    showNoRecord = true;
    paginationhide = true;
    imagePath: string = this.helper.imagePath();
    product_image_url = this.user.product_image_url;
    transactions = [];
	transactionscredit = [];
   ngOnInit(): void {
    this.SpinnerService.show();  
    this.divReady = false;
    // document.body.classList.add('bgbnnerimg');
    if (localStorage.getItem('nu_first_name') !== null) {
      this.loggedInUserFirstName = localStorage.getItem('nu_first_name');
      this.loggedInUserName = localStorage.getItem('nu_first_name');
      this.loggedInUserEmail = localStorage.getItem('nu_email');
      const user_id = localStorage.getItem('nu_c_user_id') ;
      //console.log(user_id);
      this.user.getUserPurchasedProducts(user_id).subscribe((data: any) => {
        this.productData = data.purchased_products;
        //console.log(data.purchased_products);
        if (data.status == 1) {
          this.showNoRecord = false;
        } else {
          this.showNoRecord = true;
          this.paginationhide = false;
        }
        this.divReady = true;
        this.SpinnerService.hide();
      })
		
		

      this.user.getProductTransactionsBilling(user_id).subscribe((data: any) => {
        if (data.status == 1) {
          this.transactions = data.transactions;
        }
      });
		
		
      this.user.getCreditTransactions(user_id).subscribe((data: any) => {
        if (data.status == 1) {
          this.transactionscredit = data.transactions;
        }
      });
        
    }
  }

  downloadClick(billing_id){
    this.user.downloadInvoice(billing_id).subscribe((data: any) => {
      //console.log(data);
      if(data.status == 1){
        const invoice_file = data.invoice_url;
        const download_invoice = document.querySelector('#download_invoice');
        if (download_invoice instanceof HTMLElement) {
          download_invoice.setAttribute('href', invoice_file);
          download_invoice.click();
        }
      }
    });
  }

}
